// Helper function to extract months from "11mos from today" format
export const parseMonthsFromExpiration = (expirationStatus) => {
  if (!expirationStatus) return 0;
  
  const match = expirationStatus.match(/(\d+)mos/);
  return match ? parseInt(match[1], 10) : 0;
};